// extracted by mini-css-extract-plugin
export default {"root":"BmBekPT4","menu":"rLLqNoA0","skeleton":"G0dg2kaA","reviewContainer":"ekIgoSoQ"};